import { SESSION_PHOTOS } from "../../data/content";
import { Reveal } from "../MaskedLine";

// Real photographs from Jasmeen's session library — no stock, no renders.
const SHOTS = [
  { src: SESSION_PHOTOS.stageLarge, fig: "01", alt: "Facilitation on a large stage" },
  { src: SESSION_PHOTOS.audience, fig: "02", alt: "Audience during a live session" },
  { src: SESSION_PHOTOS.cognizant, fig: "03", alt: "Corporate training room in session" },
  { src: SESSION_PHOTOS.floorActivity, fig: "04", alt: "Participants in a floor activity" },
  { src: SESSION_PHOTOS.kurtasGroup, fig: "05", alt: "Group practice during a workshop" },
  { src: SESSION_PHOTOS.bangalore, fig: "06", alt: "Workshop session in progress" },
  { src: SESSION_PHOTOS.teamMgmt, fig: "07", alt: "Team working through an exercise" },
  { src: SESSION_PHOTOS.diwaliGroup, fig: "08", alt: "Cohort group photograph" }
];

const Figure = ({ shot, aspect, testid }) => (
  <figure className="frame overflow-hidden group" data-testid={testid}>
    <div className={`${aspect} overflow-hidden`}>
      <img
        src={shot.src}
        alt={shot.alt}
        loading="lazy"
        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
      />
    </div>
    <figcaption className="stamp-dim pt-3" style={{ fontSize: 10 }}>Fig. {shot.fig} — session archive</figcaption>
  </figure>
);

export default function SessionGallery() {
  return (
    <section data-testid="session-gallery" className="ground-margin sec-pad border-t border-[color:var(--line-soft)]">
      <div className="wrap">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-12">
          <div>
            <p className="stamp mb-4" style={{ fontSize: 12 }}>The session archive</p>
            <h2 className="h-section" style={{ fontSize: "clamp(28px, 3.4vw, 46px)", lineHeight: 1.08 }}>
              Real rooms. <span className="claim">Real practice.</span>
            </h2>
          </div>
          <p className="font-body-serif measure-narrow text-[#383D5A]" style={{ fontSize: 17 }}>
            Photographs from live sessions and cohorts. No stock photography, no renders.
          </p>
        </div>

        <Reveal>
          <Figure shot={SHOTS[0]} aspect="aspect-[16/9] md:aspect-[21/9]" testid="gallery-fig-01" />
        </Reveal>

        <div className="grid grid-cols-2 md:grid-cols-12 gap-x-4 gap-y-8 md:gap-x-6 mt-8 md:mt-10">
          <Reveal className="col-span-2 md:col-span-7">
            <Figure shot={SHOTS[1]} aspect="aspect-[4/3]" testid="gallery-fig-02" />
          </Reveal>
          <Reveal className="col-span-2 md:col-span-5 md:mt-16" delay={0.05}>
            <Figure shot={SHOTS[2]} aspect="aspect-[4/5] md:aspect-[4/4]" testid="gallery-fig-03" />
          </Reveal>
          {SHOTS.slice(3, 6).map((s, i) => (
            <Reveal key={s.fig} className="col-span-1 md:col-span-4" delay={i * 0.05}>
              <Figure shot={s} aspect="aspect-[4/3]" testid={`gallery-fig-${s.fig}`} />
            </Reveal>
          ))}
          <Reveal className="col-span-1 md:col-span-6" delay={0.05}>
            <Figure shot={SHOTS[6]} aspect="aspect-[16/10]" testid="gallery-fig-07" />
          </Reveal>
          <Reveal className="col-span-1 md:col-span-6" delay={0.1}>
            <Figure shot={SHOTS[7]} aspect="aspect-[16/10]" testid="gallery-fig-08" />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
